export enum StockStatus {
  Unknown = "Unknown",
  StockItem = "StockItem",
  Incoming = "Incoming",
  DeliveryItem = "DeliveryItem",
  OutOfStock = "OutOfStock",
  SoldOut = "SoldOut",
  Hidden = "Hidden",
  PendingSoldOut = "PendingSoldOut",
  PendingOutOfStock = "PendingOutOfStock",
}

export enum ArticleStatus {
  duplicate_variant = "duplicate_variant",
  backorder_item = "backorder_item",
  stock_item = "stock_item",
  out_of_stock_at_supplier = "out_of_stock_at_supplier",
  discontinued_item = "discontinued_item",
  sales_stop = "sales_stop",
  unconfirmed = "unconfirmed",
  terminated_collaboration_sell = "terminated_collaboration_sell",
  terminated_collaboration_sales_stop = "terminated_collaboration_sales_stop",
  time_limited_keep = "time_limited_keep",
  time_limited_discontinue = "time_limited_discontinue",
  limited_keep = "limited_keep",
  limited_discontinue = "limited_discontinue",
  showroom = "showroom",
  unknown = "unknown",
}
